/**
 * @typedef {Object} StationTypeCreateDto
 * @property {string} stationTypeName
 * @property {string} stationTypeCode
 * @property {string} [description]
 * @property {string} [imageDataUrl] - full "data:image/...;base64,..." string
 */

/**
 * @typedef {Object} StationTypeUpdateDto
 * @property {string} [stationTypeName]
 * @property {string} [stationTypeCode]
 * @property {string} [description]
 * @property {boolean} [isActive]
 * @property {string} [imageDataUrl] - set a new image, '' clears it, omit to leave untouched
 */

/**
 * @typedef {Object} StationTypeResponseDto
 * @property {number} stationTypeId
 * @property {string} stationTypeName
 * @property {string} stationTypeCode
 * @property {string} [description]
 * @property {string} [imageDataUrl]
 * @property {boolean} isActive
 * @property {string} createdDate
 * @property {string} [createdBy]
 * @property {string} [modifiedDate]
 * @property {string} [modifiedBy]
 */

/**
 * @typedef {Object} StationTypeLookupDto
 * @property {number} stationTypeId
 * @property {string} stationTypeName
 * @property {string} stationTypeCode
 * @property {string} [imageDataUrl]
 */

const BASE_PATH = 'v1/StationType';

export default function (instance) {
  return {
    getStationTypes(params = {}) {
      return instance.get(BASE_PATH, { params });
    },

    getStationType(id) {
      return instance.get(`${BASE_PATH}/${id}`);
    },

    getLookups() {
      return instance.get(`${BASE_PATH}/lookups`);
    },

    /**
     * Station type lookups limited to the current user's assigned stations
     * (for the operator console's station-type picker)
     * @returns {Promise<{data: StationTypeLookupDto[]}>}
     */
    getMyLookups() {
      return instance.get(`${BASE_PATH}/my-lookups`);
    },

    createStationType(payload) {
      return instance.post(BASE_PATH, payload);
    },

    updateStationType(id, payload) {
      return instance.put(`${BASE_PATH}/${id}`, payload);
    },

    deleteStationType(id) {
      return instance.delete(`${BASE_PATH}/${id}`);
    }
  };
}
